import React from 'react';

import {
  Button,
  Grid,
  FolderSharedIcon,
  FolderIcon,
  List,
  ListItem,
  Section,
  Typography,
  ListItemText,
  ListItemIcon,
} from '@gogame/components';
import { withForm, SidePageV2, FormField } from '@gogame/form';

import { useCreateGroup, useLoadGroups } from '../data';
import { addPresetSchema } from '../schema';

export const CreatePresetForm = withForm({
  enableReinitialize: true,
  validationSchema: addPresetSchema,
})(({ onClose, onExited, open, setFieldValue, values, presetKey }) => {
  const { data: groups, isLoading, isRefetching } = useLoadGroups(presetKey);
  const [createGroup] = useCreateGroup(presetKey);
  const handleCreateGroup = () => {
    return createGroup();
  };
  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={isLoading}
      fetching={isRefetching}
      size={'sm'}
    >
      <SidePageV2.Title title={'Add Preset'} />
      <SidePageV2.Content>
        <Section title={'Name *'}>
          <FormField.TextField name={'title'} required padding={'8px 0'} />
        </Section>
        <Section title={'Group'}>
          <Grid container direction={'column'}>
            <Grid item xs={12}>
              <Button add size={'sm'} onClick={handleCreateGroup}>
                Group
              </Button>
            </Grid>
          </Grid>
        </Section>
        <List disablePadding={true} style={{ margin: '0 -16px' }}>
          {groups?.map((opt) => (
            <ListItem
              key={opt.id}
              button
              selected={values.group.id === opt.id}
              component={'div'}
              onClick={() => {
                setFieldValue('group', { id: opt.id, name: opt.title });
                setFieldValue('isPublic', opt.isPublic);
              }}
            >
              <ListItemIcon>
                {opt.isPublic ? <FolderSharedIcon /> : <FolderIcon />}
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography component={'span'}>{opt.title}</Typography>
                }
                primaryTypographyProps={{
                  component: 'div',
                }}
              />
            </ListItem>
          ))}
        </List>
      </SidePageV2.Content>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});
